import React, { useEffect, useState } from "react";

import "./styles/index.scss";
import { connect } from "react-redux";
import BreadCrumbsWidget from "../../common/widgets/breadCrumbsWidget";
import Button from "../../common/forms/button";
import MemberForm from "./memberForm";
import InvestorCreateBaseForm from "./investorCreateBaseForm";
import { createDealInvestorWithMember } from "../../../api/deals/investors";
import { clickToLinkHandler } from "../../../helpers/utils";
import { getDealById } from "../../../api/deals/deals";
import * as api from "../../../api/generated-api";
import {
  configureAuthHeader,
  configureBaseUrl,
} from "../../../api/axiosConfig";
import CustomErrorMessage from "../../common/errors/customErrorMessage";

type CreateInvestorsProps = {
  token: string;
  orgId: number;
  dealId: number;
};

const CreateInvestors = (props: CreateInvestorsProps) => {
  const { token, orgId, dealId } = props;

  configureBaseUrl();
  configureAuthHeader(token);

  const [deal, setDeal] = useState<api.Deal>(null);
  const [investor, setInvestor] = useState<
    api.DealInvestorCreate | api.DealInvestor
  >({
    name: undefined,
    targetInvestment: undefined,
    isLead: false,
    line: "",
    city: "",
    state: "",
    zip: "",
  });
  const [newPerson, setNewPerson] = useState<api.PersonCreate>({
    firstName: "",
    lastName: "",
    email: "",
  });
  const [isError, setIsError] = useState(false);

  useEffect(() => {
    if (dealId) {
      getDealById(orgId, dealId, (updatedDeal) => {
        setDeal(updatedDeal);
      });
    }
  }, [dealId]);

  if (!deal) {
    return null;
  }

  const canCreateInvestor =
    investor.name &&
    (investor.targetInvestment || investor.targetInvestment == 0) &&
    newPerson.firstName &&
    newPerson.lastName &&
    newPerson.email;

  return (
    <div className="create-deals-form-container">
      <div className="view-deals-title-container">
        <BreadCrumbsWidget {...props} />
        <Button
          data-testid="create-investor-button"
          type={(canCreateInvestor && "primary") || "disabled-primary"}
          size="medium"
          onClick={() => {
            createDealInvestorWithMember(
              orgId,
              dealId,
              { ...investor, ...newPerson },
              (createdInvestor) => {
                //redirect to investor detail page for new investor
                clickToLinkHandler(
                  "/" +
                    orgId +
                    "/deals/" +
                    createdInvestor.dealId +
                    "/edit/investors/edit/" +
                    createdInvestor.id
                );
              },
              () => {
                setIsError(true);
              }
            );
          }}
        >
          create
        </Button>
      </div>
      {isError && <CustomErrorMessage />}
      <div className="form-field-container">
        <InvestorCreateBaseForm
          investor={investor}
          onChange={(updatedInvestor) => {
            setInvestor(updatedInvestor);
          }}
        />
      </div>
      <div className="form-field-container">
        <MemberForm
          onChange={(updatedPerson) => {
            setNewPerson(updatedPerson);
          }}
        />
      </div>
    </div>
  );
};

type ReduxProps = {
  match: {
    params: {
      dealId: number;
      orgId: number;
    };
  };
};

const mapStateToProps = (state, props: ReduxProps) => {
  const {
    match: {
      params: { dealId, orgId },
    },
  } = props;
  const { token } = state.auth;
  return {
    token,
    orgId,
    dealId,
  };
};

export default connect(mapStateToProps)(CreateInvestors);
